/**
 * UID: Unique ID
 * SN: Settlement Name
 * OR: Overall Ranking
 * NE: Natural environment
 * WB: Wellbeing
 * EC: Employment and connectivity
 * HP: House Price Quality and Value
 * AP: Overall average sales price for all property (Local Authority level)
 * SPC: Annual change in average sales price for all property (Local Authority level)
 */

const data = [
    {
        "UID": 2,
        "SN": "Kirkintilloch",
        "OR": 1,
        "NE": 23,
        "WB": 10,
        "EC": 34,
        "HP": 6,
        "AP": "£276,000",
        "SPC": "1.5%"
    },
    {
        "UID": 3,
        "SN": "Blairgowrie and Rattray",
        "OR": 2,
        "NE": 10,
        "WB": 1,
        "EC": 142,
        "HP": 43,
        "AP": "£244,000",
        "SPC": "-1.2%"
    },
    {
        "UID": 4,
        "SN": "Crieff",
        "OR": 3,
        "NE": 9,
        "WB": 23,
        "EC": 111,
        "HP": 43,
        "AP": "£244,000",
        "SPC": "-1.2%"
    },
    {
        "UID": 5,
        "SN": "Selkirk",
        "OR": 4,
        "NE": 13,
        "WB": 35,
        "EC": 22,
        "HP": 68,
        "AP": "£198,000",
        "SPC": "-3.9%"
    },
    {
        "UID": 6,
        "SN": "Neilston",
        "OR": 5,
        "NE": 58,
        "WB": 39,
        "EC": 38,
        "HP": 1,
        "AP": "£291,000",
        "SPC": "-0.7%"
    },
    {
        "UID": 7,
        "SN": "Ellon",
        "OR": 6,
        "NE": 15,
        "WB": 21,
        "EC": 135,
        "HP": 21,
        "AP": "£199,000",
        "SPC": "-1.0%"
    },
    {
        "UID": 8,
        "SN": "Milngavie",
        "OR": 7,
        "NE": 66,
        "WB": 13,
        "EC": 101,
        "HP": 6,
        "AP": "£276,000",
        "SPC": "1.5%"
    },
    {
        "UID": 9,
        "SN": "Ayr",
        "OR": 8,
        "NE": 42,
        "WB": 28,
        "EC": 64,
        "HP": 10,
        "AP": "£170,000",
        "SPC": "-2.3%"
    },
    {
        "UID": 10,
        "SN": "Linlithgow",
        "OR": 9,
        "NE": 107,
        "WB": 2,
        "EC": 96,
        "HP": 14,
        "AP": "£215,000",
        "SPC": "0.9%"
    },
    {
        "UID": 11,
        "SN": "Cradlehall",
        "OR": 10,
        "NE": 49,
        "WB": 20,
        "EC": 58,
        "HP": 32,
        "AP": "£208,000",
        "SPC": "1.5%"
    },
    {
        "UID": 12,
        "SN": "Clydebank",
        "OR": 11,
        "NE": 4,
        "WB": 85,
        "EC": 3,
        "HP": 136,
        "AP": "£137,000",
        "SPC": "-1.4%"
    },
    {
        "UID": 13,
        "SN": "Peebles",
        "OR": 12,
        "NE": 77,
        "WB": 19,
        "EC": 11,
        "HP": 68,
        "AP": "£198,000",
        "SPC": "-3.9%"
    },
    {
        "UID": 14,
        "SN": "Kirkwall",
        "OR": 13,
        "NE": 21,
        "WB": 123,
        "EC": 60,
        "HP": 4,
        "AP": "£196,000",
        "SPC": "-8.4%"
    },
    {
        "UID": 15,
        "SN": "Barrhead",
        "OR": 14,
        "NE": 86,
        "WB": 70,
        "EC": 51,
        "HP": 1,
        "AP": "£291,000",
        "SPC": "-0.7%"
    },
    {
        "UID": 16,
        "SN": "Whitburn (West Lothian)",
        "OR": 15,
        "NE": 30,
        "WB": 63,
        "EC": 89,
        "HP": 14,
        "AP": "£215,000",
        "SPC": "0.9%"
    },
    {
        "UID": 17,
        "SN": "Girvan",
        "OR": 16,
        "NE": 33,
        "WB": 49,
        "EC": 106,
        "HP": 10,
        "AP": "£170,000",
        "SPC": "-2.3%"
    },
    {
        "UID": 18,
        "SN": "Linwood",
        "OR": 17,
        "NE": 7,
        "WB": 148,
        "EC": 9,
        "HP": 57,
        "AP": "£154,000",
        "SPC": "-1.9%"
    },
    {
        "UID": 19,
        "SN": "Paisley",
        "OR": 18,
        "NE": 29,
        "WB": 110,
        "EC": 5,
        "HP": 57,
        "AP": "£154,000",
        "SPC": "-1.9%"
    },
    {
        "UID": 20,
        "SN": "Stonehaven",
        "OR": 19,
        "NE": 117,
        "WB": 9,
        "EC": 84,
        "HP": 21,
        "AP": "£199,000",
        "SPC": "-1.0%"
    },
    {
        "UID": 21,
        "SN": "Bishopbriggs",
        "OR": 20,
        "NE": 86,
        "WB": 86,
        "EC": 26,
        "HP": 6,
        "AP": "£276,000",
        "SPC": "1.5%"
    },
    {
        "UID": 22,
        "SN": "Forres",
        "OR": 21,
        "NE": 96,
        "WB": 3,
        "EC": 53,
        "HP": 105,
        "AP": "£194,000",
        "SPC": "0.5%"
    },
    {
        "UID": 23,
        "SN": "Stirling",
        "OR": 22,
        "NE": 16,
        "WB": 90,
        "EC": 107,
        "HP": 40,
        "AP": "£257,000",
        "SPC": "3.2%"
    },
    {
        "UID": 24,
        "SN": "Renfrew",
        "OR": 23,
        "NE": 26,
        "WB": 104,
        "EC": 13,
        "HP": 57,
        "AP": "£154,000",
        "SPC": "-1.9%"
    },
    {
        "UID": 25,
        "SN": "Inverness",
        "OR": 24,
        "NE": 32,
        "WB": 80,
        "EC": 61,
        "HP": 32,
        "AP": "£208,000",
        "SPC": "1.5%"
    },
    {
        "UID": 26,
        "SN": "Edinburgh",
        "OR": 25,
        "NE": 24,
        "WB": 115,
        "EC": 50,
        "HP": 30,
        "AP": "£344,000",
        "SPC": "3.6%"
    },
    {
        "UID": 27,
        "SN": "Banchory",
        "OR": 26,
        "NE": 96,
        "WB": 15,
        "EC": 136,
        "HP": 21,
        "AP": "£199,000",
        "SPC": "-1.0%"
    },
    {
        "UID": 28,
        "SN": "Kelso",
        "OR": 27,
        "NE": 52,
        "WB": 6,
        "EC": 126,
        "HP": 68,
        "AP": "£198,000",
        "SPC": "-3.9%"
    },
    {
        "UID": 29,
        "SN": "Buckie",
        "OR": 28,
        "NE": 21,
        "WB": 79,
        "EC": 15,
        "HP": 105,
        "AP": "£194,000",
        "SPC": "0.5%"
    },
    {
        "UID": 30,
        "SN": "Wick (Highland)",
        "OR": 29,
        "NE": 79,
        "WB": 77,
        "EC": 18,
        "HP": 32,
        "AP": "£208,000",
        "SPC": "1.5%"
    },
    {
        "UID": 31,
        "SN": "Cumbernauld",
        "OR": 30,
        "NE": 18,
        "WB": 42,
        "EC": 32,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 32,
        "SN": "Hawick",
        "OR": 31,
        "NE": 12,
        "WB": 59,
        "EC": 129,
        "HP": 68,
        "AP": "£198,000",
        "SPC": "-3.9%"
    },
    {
        "UID": 33,
        "SN": "St Andrews",
        "OR": 32,
        "NE": 81,
        "WB": 8,
        "EC": 20,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 34,
        "SN": "Prestwick",
        "OR": 33,
        "NE": 86,
        "WB": 51,
        "EC": 91,
        "HP": 10,
        "AP": "£170,000",
        "SPC": "-2.3%"
    },
    {
        "UID": 35,
        "SN": "Bearsden",
        "OR": 34,
        "NE": 99,
        "WB": 104,
        "EC": 31,
        "HP": 6,
        "AP": "£276,000",
        "SPC": "1.5%"
    },
    {
        "UID": 36,
        "SN": "Carnoustie",
        "OR": 35,
        "NE": 110,
        "WB": 12,
        "EC": 46,
        "HP": 87,
        "AP": "£166,000",
        "SPC": "-4.0%"
    },
    {
        "UID": 37,
        "SN": "Heathhall and Locharbriggs",
        "OR": 36,
        "NE": 72,
        "WB": 7,
        "EC": 6,
        "HP": 152,
        "AP": "£169,000",
        "SPC": "2.4%"
    },
    {
        "UID": 38,
        "SN": "Kilmarnock",
        "OR": 37,
        "NE": 51,
        "WB": 53,
        "EC": 24,
        "HP": 101,
        "AP": "£128,000",
        "SPC": "-1.5%"
    },
    {
        "UID": 39,
        "SN": "Westhill",
        "OR": 38,
        "NE": 33,
        "WB": 44,
        "EC": 153,
        "HP": 21,
        "AP": "£199,000",
        "SPC": "-1.0%"
    },
    {
        "UID": 40,
        "SN": "Dumfries",
        "OR": 39,
        "NE": 11,
        "WB": 71,
        "EC": 12,
        "HP": 152,
        "AP": "£169,000",
        "SPC": "2.4%"
    },
    {
        "UID": 41,
        "SN": "Stewarton",
        "OR": 40,
        "NE": 111,
        "WB": 17,
        "EC": 40,
        "HP": 101,
        "AP": "£128,000",
        "SPC": "-1.5%"
    },
    {
        "UID": 42,
        "SN": "Forfar",
        "OR": 41,
        "NE": 45,
        "WB": 78,
        "EC": 14,
        "HP": 87,
        "AP": "£166,000",
        "SPC": "-4.0%"
    },
    {
        "UID": 43,
        "SN": "Johnstone",
        "OR": 42,
        "NE": 60,
        "WB": 124,
        "EC": 4,
        "HP": 57,
        "AP": "£154,000",
        "SPC": "-1.9%"
    },
    {
        "UID": 44,
        "SN": "Gorebridge and Mayfield",
        "OR": 43,
        "NE": 20,
        "WB": 89,
        "EC": 104,
        "HP": 63,
        "AP": "£242,000",
        "SPC": "2.5%"
    },
    {
        "UID": 45,
        "SN": "Penicuik",
        "OR": 44,
        "NE": 25,
        "WB": 71,
        "EC": 118,
        "HP": 63,
        "AP": "£242,000",
        "SPC": "2.5%"
    },
    {
        "UID": 46,
        "SN": "Kilwinning",
        "OR": 45,
        "NE": 38,
        "WB": 30,
        "EC": 112,
        "HP": 75,
        "AP": "£127,000",
        "SPC": "-3.8%"
    },
    {
        "UID": 47,
        "SN": "Perth",
        "OR": 46,
        "NE": 39,
        "WB": 103,
        "EC": 55,
        "HP": 43,
        "AP": "£244,000",
        "SPC": "-1.2%"
    },
    {
        "UID": 48,
        "SN": "Kilbirnie",
        "OR": 47,
        "NE": 61,
        "WB": 67,
        "EC": 16,
        "HP": 75,
        "AP": "£127,000",
        "SPC": "-3.8%"
    },
    {
        "UID": 49,
        "SN": "Inverurie",
        "OR": 48,
        "NE": 70,
        "WB": 48,
        "EC": 132,
        "HP": 21,
        "AP": "£199,000",
        "SPC": "-1.0%"
    },
    {
        "UID": 50,
        "SN": "Monifieth",
        "OR": 49,
        "NE": 90,
        "WB": 41,
        "EC": 24,
        "HP": 87,
        "AP": "£166,000",
        "SPC": "-4.0%"
    },
    {
        "UID": 51,
        "SN": "Stevenston",
        "OR": 50,
        "NE": 47,
        "WB": 82,
        "EC": 36,
        "HP": 75,
        "AP": "£127,000",
        "SPC": "-3.8%"
    },
    {
        "UID": 52,
        "SN": "Dunoon",
        "OR": 51,
        "NE": 17,
        "WB": 128,
        "EC": 37,
        "HP": 84,
        "AP": "£194,000",
        "SPC": "-3.0%"
    },
    {
        "UID": 53,
        "SN": "Livingston",
        "OR": 52,
        "NE": 82,
        "WB": 90,
        "EC": 88,
        "HP": 14,
        "AP": "£215,000",
        "SPC": "0.9%"
    },
    {
        "UID": 54,
        "SN": "Annan",
        "OR": 53,
        "NE": 6,
        "WB": 67,
        "EC": 79,
        "HP": 152,
        "AP": "£169,000",
        "SPC": "2.4%"
    },
    {
        "UID": 55,
        "SN": "Rutherglen",
        "OR": 54,
        "NE": 59,
        "WB": 153,
        "EC": 2,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 56,
        "SN": "Bonnyrigg",
        "OR": 55,
        "NE": 64,
        "WB": 40,
        "EC": 110,
        "HP": 63,
        "AP": "£242,000",
        "SPC": "2.5%"
    },
    {
        "UID": 57,
        "SN": "Bathgate",
        "OR": 56,
        "NE": 36,
        "WB": 147,
        "EC": 56,
        "HP": 14,
        "AP": "£215,000",
        "SPC": "0.9%"
    },
    {
        "UID": 58,
        "SN": "Cambuslang",
        "OR": 57,
        "NE": 39,
        "WB": 108,
        "EC": 59,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 59,
        "SN": "East Kilbride",
        "OR": 58,
        "NE": 104,
        "WB": 86,
        "EC": 32,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 60,
        "SN": "Carluke",
        "OR": 59,
        "NE": 50,
        "WB": 49,
        "EC": 129,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 61,
        "SN": "Elderslie",
        "OR": 60,
        "NE": 36,
        "WB": 139,
        "EC": 20,
        "HP": 57,
        "AP": "£154,000",
        "SPC": "-1.9%"
    },
    {
        "UID": 62,
        "SN": "Lanark",
        "OR": 61,
        "NE": 54,
        "WB": 64,
        "EC": 119,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 63,
        "SN": "Kelty",
        "OR": 62,
        "NE": 118,
        "WB": 5,
        "EC": 48,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 64,
        "SN": "Alexandria",
        "OR": 63,
        "NE": 1,
        "WB": 135,
        "EC": 67,
        "HP": 136,
        "AP": "£137,000",
        "SPC": "-1.4%"
    },
    {
        "UID": 65,
        "SN": "Galashiels",
        "OR": 64,
        "NE": 64,
        "WB": 96,
        "EC": 45,
        "HP": 68,
        "AP": "£198,000",
        "SPC": "-3.9%"
    },
    {
        "UID": 66,
        "SN": "Newton Mearns",
        "OR": 65,
        "NE": 126,
        "WB": 93,
        "EC": 101,
        "HP": 1,
        "AP": "£291,000",
        "SPC": "-0.7%"
    },
    {
        "UID": 67,
        "SN": "Troon (South Ayrshire)",
        "OR": 66,
        "NE": 56,
        "WB": 132,
        "EC": 99,
        "HP": 10,
        "AP": "£170,000",
        "SPC": "-2.3%"
    },
    {
        "UID": 68,
        "SN": "Dumbarton",
        "OR": 67,
        "NE": 8,
        "WB": 61,
        "EC": 137,
        "HP": 136,
        "AP": "£137,000",
        "SPC": "-1.4%"
    },
    {
        "UID": 69,
        "SN": "Balloch",
        "OR": 68,
        "NE": 2,
        "WB": 96,
        "EC": 121,
        "HP": 136,
        "AP": "£137,000",
        "SPC": "-1.4%"
    },
    {
        "UID": 70,
        "SN": "Armadale",
        "OR": 69,
        "NE": 156,
        "WB": 25,
        "EC": 80,
        "HP": 14,
        "AP": "£215,000",
        "SPC": "0.9%"
    },
    {
        "UID": 71,
        "SN": "Arbroath",
        "OR": 70,
        "NE": 48,
        "WB": 56,
        "EC": 114,
        "HP": 87,
        "AP": "£166,000",
        "SPC": "-4.0%"
    },
    {
        "UID": 72,
        "SN": "Erskine",
        "OR": 71,
        "NE": 92,
        "WB": 113,
        "EC": 22,
        "HP": 57,
        "AP": "£154,000",
        "SPC": "-1.9%"
    },
    {
        "UID": 73,
        "SN": "Bo'ness",
        "OR": 72,
        "NE": 132,
        "WB": 13,
        "EC": 8,
        "HP": 141,
        "AP": "£168,000",
        "SPC": "4.3%"
    },
    {
        "UID": 74,
        "SN": "Turriff",
        "OR": 73,
        "NE": 112,
        "WB": 45,
        "EC": 145,
        "HP": 21,
        "AP": "£199,000",
        "SPC": "-1.0%"
    },
    {
        "UID": 75,
        "SN": "Brechin",
        "OR": 74,
        "NE": 115,
        "WB": 74,
        "EC": 18,
        "HP": 87,
        "AP": "£166,000",
        "SPC": "-4.0%"
    },
    {
        "UID": 76,
        "SN": "Kirriemuir",
        "OR": 75,
        "NE": 94,
        "WB": 75,
        "EC": 38,
        "HP": 87,
        "AP": "£166,000",
        "SPC": "-4.0%"
    },
    {
        "UID": 77,
        "SN": "Gourock",
        "OR": 76,
        "NE": 3,
        "WB": 53,
        "EC": 129,
        "HP": 159,
        "AP": "£132,000",
        "SPC": "2.3%"
    },
    {
        "UID": 78,
        "SN": "Dunbar",
        "OR": 77,
        "NE": 84,
        "WB": 55,
        "EC": 64,
        "HP": 94,
        "AP": "£348,000",
        "SPC": "15.2%"
    },
    {
        "UID": 79,
        "SN": "Strathaven",
        "OR": 78,
        "NE": 94,
        "WB": 21,
        "EC": 153,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 80,
        "SN": "Cockenzie and Port Seton",
        "OR": 79,
        "NE": 136,
        "WB": 10,
        "EC": 93,
        "HP": 94,
        "AP": "£348,000",
        "SPC": "15.2%"
    },
    {
        "UID": 81,
        "SN": "Fraserburgh",
        "OR": 80,
        "NE": 4,
        "WB": 161,
        "EC": 138,
        "HP": 21,
        "AP": "£199,000",
        "SPC": "-1.0%"
    },
    {
        "UID": 82,
        "SN": "Nairn",
        "OR": 81,
        "NE": 120,
        "WB": 26,
        "EC": 144,
        "HP": 32,
        "AP": "£208,000",
        "SPC": "1.5%"
    },
    {
        "UID": 83,
        "SN": "Prestonpans",
        "OR": 82,
        "NE": 52,
        "WB": 83,
        "EC": 91,
        "HP": 94,
        "AP": "£348,000",
        "SPC": "15.2%"
    },
    {
        "UID": 84,
        "SN": "Lochgelly",
        "OR": 83,
        "NE": 82,
        "WB": 32,
        "EC": 71,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 85,
        "SN": "Dunblane",
        "OR": 84,
        "NE": 107,
        "WB": 17,
        "EC": 159,
        "HP": 40,
        "AP": "£257,000",
        "SPC": "3.2%"
    },
    {
        "UID": 86,
        "SN": "Largs",
        "OR": 85,
        "NE": 105,
        "WB": 71,
        "EC": 61,
        "HP": 75,
        "AP": "£127,000",
        "SPC": "-3.8%"
    },
    {
        "UID": 87,
        "SN": "Dundee",
        "OR": 86,
        "NE": 45,
        "WB": 144,
        "EC": 1,
        "HP": 150,
        "AP": "£154,000",
        "SPC": "0.7%"
    },
    {
        "UID": 88,
        "SN": "Blackburn (West Lothian)",
        "OR": 87,
        "NE": 86,
        "WB": 127,
        "EC": 116,
        "HP": 14,
        "AP": "£215,000",
        "SPC": "0.9%"
    },
    {
        "UID": 89,
        "SN": "Beith",
        "OR": 88,
        "NE": 134,
        "WB": 28,
        "EC": 69,
        "HP": 75,
        "AP": "£127,000",
        "SPC": "-3.8%"
    },
    {
        "UID": 90,
        "SN": "Peterhead",
        "OR": 89,
        "NE": 27,
        "WB": 148,
        "EC": 142,
        "HP": 21,
        "AP": "£199,000",
        "SPC": "-1.0%"
    },
    {
        "UID": 91,
        "SN": "Broxburn (West Lothian)",
        "OR": 90,
        "NE": 143,
        "WB": 102,
        "EC": 42,
        "HP": 14,
        "AP": "£215,000",
        "SPC": "0.9%"
    },
    {
        "UID": 92,
        "SN": "Portlethen",
        "OR": 91,
        "NE": 151,
        "WB": 16,
        "EC": 150,
        "HP": 21,
        "AP": "£199,000",
        "SPC": "-1.0%"
    },
    {
        "UID": 93,
        "SN": "Bridge of Allan",
        "OR": 92,
        "NE": 119,
        "WB": 24,
        "EC": 157,
        "HP": 40,
        "AP": "£257,000",
        "SPC": "3.2%"
    },
    {
        "UID": 94,
        "SN": "Haddington",
        "OR": 93,
        "NE": 99,
        "WB": 47,
        "EC": 112,
        "HP": 94,
        "AP": "£348,000",
        "SPC": "15.2%"
    },
    {
        "UID": 95,
        "SN": "Bonhill and Renton",
        "OR": 94,
        "NE": 71,
        "WB": 37,
        "EC": 96,
        "HP": 136,
        "AP": "£137,000",
        "SPC": "-1.4%"
    },
    {
        "UID": 96,
        "SN": "Lerwick",
        "OR": 95,
        "NE": 28,
        "WB": 160,
        "EC": 147,
        "HP": 5,
        "AP": "£173,000",
        "SPC": "-8.0%"
    },
    {
        "UID": 97,
        "SN": "Coatbridge",
        "OR": 96,
        "NE": 39,
        "WB": 109,
        "EC": 54,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 98,
        "SN": "Airdrie",
        "OR": 97,
        "NE": 44,
        "WB": 90,
        "EC": 86,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 99,
        "SN": "Helensburgh",
        "OR": 98,
        "NE": 35,
        "WB": 36,
        "EC": 160,
        "HP": 84,
        "AP": "£194,000",
        "SPC": "-3.0%"
    },
    {
        "UID": 100,
        "SN": "Oban",
        "OR": 99,
        "NE": 72,
        "WB": 157,
        "EC": 6,
        "HP": 84,
        "AP": "£194,000",
        "SPC": "-3.0%"
    },
    {
        "UID": 101,
        "SN": "Lossiemouth",
        "OR": 100,
        "NE": 126,
        "WB": 37,
        "EC": 70,
        "HP": 105,
        "AP": "£194,000",
        "SPC": "0.5%"
    },
    {
        "UID": 102,
        "SN": "Fort William",
        "OR": 101,
        "NE": 62,
        "WB": 119,
        "EC": 138,
        "HP": 32,
        "AP": "£208,000",
        "SPC": "1.5%"
    },
    {
        "UID": 103,
        "SN": "Saltcoats",
        "OR": 102,
        "NE": 90,
        "WB": 130,
        "EC": 41,
        "HP": 75,
        "AP": "£127,000",
        "SPC": "-3.8%"
    },
    {
        "UID": 104,
        "SN": "Dunfermline",
        "OR": 103,
        "NE": 93,
        "WB": 51,
        "EC": 86,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 105,
        "SN": "Irvine",
        "OR": 104,
        "NE": 84,
        "WB": 124,
        "EC": 52,
        "HP": 75,
        "AP": "£127,000",
        "SPC": "-3.8%"
    },
    {
        "UID": 106,
        "SN": "Shotts",
        "OR": 105,
        "NE": 57,
        "WB": 84,
        "EC": 75,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 107,
        "SN": "Dingwall",
        "OR": 106,
        "NE": 62,
        "WB": 98,
        "EC": 155,
        "HP": 32,
        "AP": "£208,000",
        "SPC": "1.5%"
    },
    {
        "UID": 108,
        "SN": "Stranraer",
        "OR": 107,
        "NE": 18,
        "WB": 67,
        "EC": 134,
        "HP": 152,
        "AP": "£169,000",
        "SPC": "2.4%"
    },
    {
        "UID": 109,
        "SN": "Cupar",
        "OR": 108,
        "NE": 103,
        "WB": 100,
        "EC": 16,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 110,
        "SN": "Glasgow",
        "OR": 109,
        "NE": 14,
        "WB": 156,
        "EC": 29,
        "HP": 149,
        "AP": "£184,000",
        "SPC": "4.5%"
    },
    {
        "UID": 111,
        "SN": "North Berwick",
        "OR": 110,
        "NE": 140,
        "WB": 4,
        "EC": 151,
        "HP": 94,
        "AP": "£348,000",
        "SPC": "15.2%"
    },
    {
        "UID": 112,
        "SN": "Larbert and Stenhousemuir",
        "OR": 111,
        "NE": 30,
        "WB": 46,
        "EC": 140,
        "HP": 141,
        "AP": "£168,000",
        "SPC": "4.3%"
    },
    {
        "UID": 113,
        "SN": "Dalgety Bay",
        "OR": 112,
        "NE": 124,
        "WB": 27,
        "EC": 84,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 114,
        "SN": "Montrose",
        "OR": 113,
        "NE": 112,
        "WB": 57,
        "EC": 124,
        "HP": 87,
        "AP": "£166,000",
        "SPC": "-4.0%"
    },
    {
        "UID": 115,
        "SN": "Loanhead",
        "OR": 114,
        "NE": 105,
        "WB": 122,
        "EC": 90,
        "HP": 63,
        "AP": "£242,000",
        "SPC": "2.5%"
    },
    {
        "UID": 116,
        "SN": "Ballingry and Lochore",
        "OR": 115,
        "NE": 151,
        "WB": 32,
        "EC": 35,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 117,
        "SN": "Kilsyth",
        "OR": 116,
        "NE": 67,
        "WB": 115,
        "EC": 46,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 118,
        "SN": "Larkhall",
        "OR": 117,
        "NE": 155,
        "WB": 61,
        "EC": 63,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 119,
        "SN": "Tranent",
        "OR": 118,
        "NE": 96,
        "WB": 120,
        "EC": 80,
        "HP": 94,
        "AP": "£348,000",
        "SPC": "15.2%"
    },
    {
        "UID": 120,
        "SN": "SteÃ²rnabhagh",
        "OR": 119,
        "NE": 67,
        "WB": 101,
        "EC": 128,
        "HP": 104,
        "AP": "£176,000",
        "SPC": "9.3%"
    },
    {
        "UID": 121,
        "SN": "Cults",
        "OR": 120,
        "NE": 99,
        "WB": 42,
        "EC": 158,
        "HP": 73,
        "AP": "£141,000",
        "SPC": "-2.8%"
    },
    {
        "UID": 122,
        "SN": "Thurso",
        "OR": 121,
        "NE": 129,
        "WB": 75,
        "EC": 146,
        "HP": 32,
        "AP": "£208,000",
        "SPC": "1.5%"
    },
    {
        "UID": 123,
        "SN": "Elgin",
        "OR": 122,
        "NE": 120,
        "WB": 110,
        "EC": 43,
        "HP": 105,
        "AP": "£194,000",
        "SPC": "0.5%"
    },
    {
        "UID": 124,
        "SN": "Dalry",
        "OR": 123,
        "NE": 123,
        "WB": 113,
        "EC": 57,
        "HP": 75,
        "AP": "£127,000",
        "SPC": "-3.8%"
    },
    {
        "UID": 125,
        "SN": "Ardrossan",
        "OR": 124,
        "NE": 112,
        "WB": 128,
        "EC": 64,
        "HP": 75,
        "AP": "£127,000",
        "SPC": "-3.8%"
    },
    {
        "UID": 126,
        "SN": "Camelon",
        "OR": 125,
        "NE": 72,
        "WB": 99,
        "EC": 71,
        "HP": 141,
        "AP": "£168,000",
        "SPC": "4.3%"
    },
    {
        "UID": 127,
        "SN": "Hamilton",
        "OR": 126,
        "NE": 125,
        "WB": 136,
        "EC": 73,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 128,
        "SN": "Aberdeen",
        "OR": 127,
        "NE": 72,
        "WB": 152,
        "EC": 94,
        "HP": 73,
        "AP": "£141,000",
        "SPC": "-2.8%"
    },
    {
        "UID": 129,
        "SN": "Dalkeith",
        "OR": 128,
        "NE": 109,
        "WB": 141,
        "EC": 122,
        "HP": 63,
        "AP": "£242,000",
        "SPC": "2.5%"
    },
    {
        "UID": 130,
        "SN": "Broughty Ferry",
        "OR": 129,
        "NE": 141,
        "WB": 81,
        "EC": 26,
        "HP": 150,
        "AP": "£154,000",
        "SPC": "0.7%"
    },
    {
        "UID": 131,
        "SN": "Musselburgh",
        "OR": 130,
        "NE": 76,
        "WB": 146,
        "EC": 124,
        "HP": 94,
        "AP": "£348,000",
        "SPC": "15.2%"
    },
    {
        "UID": 132,
        "SN": "Queensferry",
        "OR": 131,
        "NE": 144,
        "WB": 142,
        "EC": 100,
        "HP": 30,
        "AP": "£344,000",
        "SPC": "3.6%"
    },
    {
        "UID": 133,
        "SN": "Stonehouse (South Lanarkshire)",
        "OR": 132,
        "NE": 159,
        "WB": 58,
        "EC": 127,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 134,
        "SN": "Burntisland",
        "OR": 133,
        "NE": 137,
        "WB": 93,
        "EC": 75,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 135,
        "SN": "Cumnock",
        "OR": 134,
        "NE": 161,
        "WB": 31,
        "EC": 116,
        "HP": 101,
        "AP": "£128,000",
        "SPC": "-1.5%"
    },
    {
        "UID": 136,
        "SN": "Kirkcaldy",
        "OR": 135,
        "NE": 145,
        "WB": 115,
        "EC": 30,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 137,
        "SN": "Kennoway",
        "OR": 135,
        "NE": 146,
        "WB": 65,
        "EC": 104,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 138,
        "SN": "Chapelhall",
        "OR": 137,
        "NE": 153,
        "WB": 95,
        "EC": 49,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 139,
        "SN": "Blantyre",
        "OR": 138,
        "NE": 150,
        "WB": 130,
        "EC": 109,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 140,
        "SN": "Uddingston",
        "OR": 139,
        "NE": 79,
        "WB": 139,
        "EC": 123,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 141,
        "SN": "Alness",
        "OR": 140,
        "NE": 77,
        "WB": 143,
        "EC": 161,
        "HP": 32,
        "AP": "£208,000",
        "SPC": "1.5%"
    },
    {
        "UID": 142,
        "SN": "Cowdenbeath",
        "OR": 141,
        "NE": 134,
        "WB": 121,
        "EC": 67,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 143,
        "SN": "Motherwell",
        "OR": 142,
        "NE": 132,
        "WB": 106,
        "EC": 98,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 144,
        "SN": "Bothwell",
        "OR": 143,
        "NE": 131,
        "WB": 133,
        "EC": 148,
        "HP": 46,
        "AP": "£168,000",
        "SPC": "1.8%"
    },
    {
        "UID": 145,
        "SN": "Port Glasgow",
        "OR": 144,
        "NE": 67,
        "WB": 137,
        "EC": 77,
        "HP": 159,
        "AP": "£132,000",
        "SPC": "2.3%"
    },
    {
        "UID": 146,
        "SN": "Tullibody",
        "OR": 145,
        "NE": 99,
        "WB": 65,
        "EC": 152,
        "HP": 156,
        "AP": "£177,000",
        "SPC": "6.6%"
    },
    {
        "UID": 147,
        "SN": "Wishaw",
        "OR": 146,
        "NE": 115,
        "WB": 154,
        "EC": 80,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 148,
        "SN": "Brightons, Redding and Maddiston",
        "OR": 147,
        "NE": 142,
        "WB": 32,
        "EC": 156,
        "HP": 141,
        "AP": "£168,000",
        "SPC": "4.3%"
    },
    {
        "UID": 149,
        "SN": "Alloa",
        "OR": 148,
        "NE": 43,
        "WB": 150,
        "EC": 133,
        "HP": 156,
        "AP": "£177,000",
        "SPC": "6.6%"
    },
    {
        "UID": 150,
        "SN": "Glenrothes",
        "OR": 149,
        "NE": 157,
        "WB": 134,
        "EC": 43,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 151,
        "SN": "Moodiesburn",
        "OR": 150,
        "NE": 129,
        "WB": 144,
        "EC": 73,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 152,
        "SN": "Tillicoultry",
        "OR": 151,
        "NE": 120,
        "WB": 59,
        "EC": 149,
        "HP": 156,
        "AP": "£177,000",
        "SPC": "6.6%"
    },
    {
        "UID": 153,
        "SN": "Falkirk",
        "OR": 152,
        "NE": 139,
        "WB": 107,
        "EC": 114,
        "HP": 141,
        "AP": "£168,000",
        "SPC": "4.3%"
    },
    {
        "UID": 154,
        "SN": "Leven (Fife)",
        "OR": 153,
        "NE": 148,
        "WB": 154,
        "EC": 26,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 155,
        "SN": "Rosyth",
        "OR": 153,
        "NE": 147,
        "WB": 124,
        "EC": 94,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 156,
        "SN": "Bellshill",
        "OR": 155,
        "NE": 126,
        "WB": 151,
        "EC": 77,
        "HP": 125,
        "AP": "£141,000",
        "SPC": "2.2%"
    },
    {
        "UID": 157,
        "SN": "Greenock",
        "OR": 156,
        "NE": 55,
        "WB": 158,
        "EC": 107,
        "HP": 159,
        "AP": "£132,000",
        "SPC": "2.3%"
    },
    {
        "UID": 158,
        "SN": "Bonnybridge",
        "OR": 157,
        "NE": 154,
        "WB": 88,
        "EC": 120,
        "HP": 141,
        "AP": "£168,000",
        "SPC": "4.3%"
    },
    {
        "UID": 159,
        "SN": "Methil",
        "OR": 158,
        "NE": 158,
        "WB": 158,
        "EC": 10,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    },
    {
        "UID": 160,
        "SN": "Grangemouth",
        "OR": 159,
        "NE": 148,
        "WB": 138,
        "EC": 80,
        "HP": 141,
        "AP": "£168,000",
        "SPC": "4.3%"
    },
    {
        "UID": 161,
        "SN": "Denny",
        "OR": 160,
        "NE": 138,
        "WB": 118,
        "EC": 141,
        "HP": 141,
        "AP": "£168,000",
        "SPC": "4.3%"
    },
    {
        "UID": 162,
        "SN": "Inverkeithing",
        "OR": 161,
        "NE": 160,
        "WB": 110,
        "EC": 101,
        "HP": 109,
        "AP": "£180,000",
        "SPC": "4.0%"
    }
]

export default data;
